/**
 * Opens Loox review form popup (no page navigation).
 * Uses window.looxWrite / LOOX.showReviewForm when available.
 */
(function () {
  if (window.__nnhLooxWriteBound) return;
  window.__nnhLooxWriteBound = true;

  function openLooxReviewForm(productId) {
    var id = String(productId);
    if (typeof window.looxWrite === 'function') {
      window.looxWrite(id);
      return true;
    }
    if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') {
      window.LOOX.showReviewForm(id);
      return true;
    }
    return false;
  }

  function tryOpen(btn, attempt) {
    var productId = btn.getAttribute('data-loox-product-id');
    if (!productId) return;

    if (openLooxReviewForm(productId)) return;

    if (attempt < 20) {
      setTimeout(function () {
        tryOpen(btn, attempt + 1);
      }, 250);
      return;
    }

    var fallback = btn.getAttribute('data-loox-fallback-url');
    if (fallback) {
      window.location.href = fallback;
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-loox-write-review]');
    if (!btn) return;

    event.preventDefault();
    tryOpen(btn, 0);
  });
})();
